<script>
  import IoLogoTwitter from 'svelte-icons/io/IoLogoTwitter.svelte'
  import IoLogoGithub from 'svelte-icons/io/IoLogoGithub.svelte'
  import FaYoutube from 'svelte-icons/fa/FaYoutube.svelte'
  import FaKeybase from 'svelte-icons/fa/FaKeybase.svelte'
  import FaChevronDown from 'svelte-icons/fa/FaChevronDown.svelte'
  import FaCoffee from 'svelte-icons/fa/FaCoffee.svelte'
  import FaTelegramPlane from 'svelte-icons/fa/FaTelegramPlane.svelte'
  import FaAmazon from 'svelte-icons/fa/FaAmazon.svelte'
  import FaPenNib from 'svelte-icons/fa/FaPenNib.svelte'
  import FaVrCardboard from 'svelte-icons/fa/FaVrCardboard.svelte'
  import { _, init, addMessages, getLocaleFromNavigator } from 'svelte-i18n'

  import en from './en.json'
  import ja from './ja.json'
  import myWorks from './works.json'
  import Skill from './skill.json'

  addMessages('en', en)
  addMessages('ja', ja)

  init({
    fallbackLocale: 'en',
    initialLocale: getLocaleFromNavigator(),
  })

  const mail = 'ainznino@pm.me'

  export const SNS = [
    {
      title: 'Twitter',
      icon: IoLogoTwitter,
      url: 'https://twitter.com/scgame_m',
    },
    {
      title: 'Github',
      icon: IoLogoGithub,
      url: 'https://github.com/opera7133',
    },
    {
      title: 'Youtube',
      icon: FaYoutube,
      url: 'https://www.youtube.com/channel/UCWwPrIQCPvjH3mce-CVfCIA',
    },
    { title: 'Keybase', icon: FaKeybase, url: 'https://keybase.io/opera7133' },
    { title: 'Telegram', icon: FaTelegramPlane, url: 'https://t.me/wamo_sc' },
    {
      title: 'VRChat',
      icon: FaVrCardboard,
      url:
        'https://vrchat.com/home/user/usr_f5d27827-3a96-45ba-921f-10b0d2aa4213',
    },
    { title: 'Ko-fi', icon: FaCoffee, url: 'https://ko-fi.com/wamosc' },
    {
      title: 'Amazon',
      icon: FaAmazon,
      url: 'https://www.amazon.jp/hz/wishlist/ls/2ST3GH743NLVN?ref_=wl_share',
    },
    {
      title: 'Blog',
      icon: FaPenNib,
      url: 'https://blog.wmsci.com',
    },
  ]

  function reveal() {
    var reveals = document.querySelectorAll('.reveal')

    for (var i = 0; i < reveals.length; i++) {
      var windowHeight = window.innerHeight
      var elementTop = reveals[i].getBoundingClientRect().top
      var elementVisible = 150

      if (
        elementTop < windowHeight - elementVisible &&
        !reveals[i].classList.contains('motion-safe:animate-fadeIn')
      ) {
        reveals[i].classList.add('motion-safe:animate-fadeIn')
        if (reveals[i].classList.contains('opacity-0')) {
          reveals[i].classList.remove('opacity-0')
        }
      }
    }
  }

  window.addEventListener('scroll', reveal)
</script>

<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
  .icon {
    width: 32px;
    height: 32px;
  }
  html {
    font-feature-settings: 'palt';
    scroll-behavior: smooth;
  }
</style>

<svelte:head>
  <style>
    @import url('https://fonts.googleapis.com/css?family=Poppins&family=Noto+Sans+JP&display=swap');
  </style>
</svelte:head>
<main class="dark:bg-zinc-800 overflow-x-hidden">
  <div
    class="dark:text-white px-5 flex justify-center items-center min-h-screen
    flex-col">
    <div class="items-center container max-w-6xl motion-safe:animate-fadeIn">
      <h1 class="lowercase text-6xl pb-5">wamo</h1>
      <p class="text-2xl">{$_('short_about')}</p>
      <div class="pt-5 flex flex-row flex-wrap items-center">
        {#each SNS as sns}
          <a
            href={sns.url}
            target="_blank"
            aria-label={sns.title}
            rel="noopener noreferrer">
            <div
              class="w-8 mx-2 duration-100 hover:opacity-80 text-black
              dark:text-white">
              <svelte:component this={sns.icon} />
            </div>
          </a>
        {/each}
      </div>
    </div>
    <a
      class="border-0 focus:outline-none absolute bottom-8 w-6 h-6
      animate-bounce cursor-pointer text-black left-1/2"
      href="/#about"
      aria-label="Next Section">
      <div class="relative -left-1/2 text-black dark:text-white">
        <FaChevronDown />
      </div>
    </a>
  </div>
  <div
    class="px-5 py-40 flex justify-center items-center min-h-screen flex-col
    reveal opacity-0"
    id="about">
    <div class="relative items-center container max-w-4xl">
      <div
        class="bg-amber-500 rounded-lg shadow-md shadow-amber-300
        dark:shadow-amber-800 absolute py-14 px-40 -top-14 -left-10 transform
        -rotate-6 z-0" />
    </div>
    <div class="relative items-center container max-w-4xl">
      <div
        class="bg-white dark:bg-zinc-700 dark:text-white rounded-lg shadow-xl
        p-10">
        <h2 class="text-5xl font-medium">About</h2>
        <img
          class="absolute right-5 -top-10 rounded-full h-28"
          src="/img/icon.webp"
          alt="avatar" />
        <p class="py-3 text-xl">{$_('long_about')}</p>
        <div
          class="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 max-w-xs
          lg:max-w-lg">
          {#each Skill as skill}
            <div class="relative m-1">
              <div
                class="percent w-24 h-24 rounded-full"
                style="background-image: conic-gradient({skill.color} 0% {skill.per}%,
                #d9d9d9 {skill.per}% 100%);" />
              <div
                class="absolute top-2 left-2 bg-white dark:bg-zinc-700 w-20 h-20
                rounded-full">
                <p class="pt-7 text-center">{skill.title}</p>
              </div>
            </div>
          {/each}
        </div>
        <div
          class="bg-cyan-500 rounded-lg shadow-md shadow-cyan-300
          dark:shadow-cyan-800 absolute right-0 md:-right-10 py-14 px-20
          transform rotate-12" />
      </div>
    </div>
  </div>
  <div
    class="px-5 relative flex justify-center items-center min-h-screen flex-col
    reveal opacity-0"
    id="contact">
    <div class="items-center container max-w-4xl">
      <div
        class="bg-white dark:bg-zinc-700 dark:text-white border-0 rounded-lg
        shadow-xl p-10">
        <h2 class="mb-5 text-5xl font-medium">What I'm doing</h2>
        <div
          class="relative border-l-2 dark:border-color-white border-solid py-3
          px-5">
          <div
            class="bg-white rounded-full border-2 border-gray-300 absolute p-2
            -left-[11px] top-5" />
          <h3 class="text-2xl">{$_('future')}</h3>
          <time>20xx/xx</time>
        </div>
        <div
          class="relative border-l-2 dark:border-color-white border-solid py-3
          px-5">
          <div
            class="bg-white rounded-full border-2 border-gray-300 absolute p-2
            -left-[11px] top-5" />
          <h3 class="text-2xl">{$_('it_secman')}</h3>
          <time>2021/12</time>
        </div>
        <div
          class="relative border-l-2 dark:border-color-white border-solid py-3
          px-5">
          <div
            class="bg-white rounded-full border-2 border-gray-300 absolute p-2
            -left-[11px] top-5" />
          <h3 class="text-2xl">{$_('entered_tmcit')}</h3>
          <time>2021/04</time>
        </div>
      </div>
    </div>
  </div>
  <div
    class="px-5 flex min-h-screen justify-center items-center h-full flex-col
    py-32 reveal opacity-0"
    id="works">
    <div class="items-center container max-w-6xl">
      <div
        class="bg-white dark:bg-zinc-700 dark:text-white rounded-lg shadow-xl
        p-5 md:p-10">
        <h2 class="text-5xl font-medium">Works</h2>
        <p class="text-xl py-3">{$_('works')}</p>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
          {#each myWorks as work}
            <div>
              <a href={work.url} target="_blank" rel="noopener noreferrer">
                <img
                  class="rounded-lg hover:opacity-70 duration-200"
                  src={work.image}
                  alt={work.title} />
              </a>
            </div>
          {/each}
        </div>
      </div>
    </div>
  </div>
  <div
    class="px-5 relative flex justify-center items-center min-h-screen flex-col
    reveal opacity-0"
    id="contact">
    <div class="items-center container max-w-4xl">
      <div
        class="bg-white dark:bg-zinc-700 dark:text-white border-0 rounded-lg
        shadow-xl p-10">
        <h2 class="text-5xl font-medium">Get in touch</h2>
        <p class="py-3 text-xl">{$_('contact')}</p>
        <p class="text-xl">
          E-Mail:
          <a
            class="text-blue-600 border-b-2 leading-3 border-transparent
            hover:border-blue-500 duration-200 visited:text-purple-600
            visited:hover:border-purple-600"
            href="mailto:{mail}">
            {mail}
          </a>
        </p>
        <p class="text-xl">
          Twitter:
          <a
            class="text-blue-600 border-b-2 leading-3 border-transparent
            hover:border-blue-500 duration-200 visited:text-purple-600
            visited:hover:border-purple-600"
            href="https://twitter.com/scgame_m">
            @scgame_m
          </a>
        </p>
      </div>
    </div>
    <div class="absolute bottom-0 left-0 py-3 px-5 dark:text-white">
      &copy; 2021
      <a href="/" class="text-blue-600 hover:opacity-70 duration-200">wamo</a>
    </div>
  </div>
</main>
